module.exports = __webpack_public_path__ + "area_beijing_dark.1d20d947.png";